import { createSelector } from '@reduxjs/toolkit';
import { AdminState } from 'reduxStore/appStore';

import { OnboardSurveysState } from './initialState';

export const selectOnboardSurveysDomain = (state: AdminState) =>
  state.onboardSurveys as OnboardSurveysState.Domain;

export const selectOnboardSurveysResource = createSelector(
  selectOnboardSurveysDomain,
  ({ resource }) => resource,
);

export const selectOnboardSurveys = createSelector(
  selectOnboardSurveysResource,
  ({ data }) => data?.onboardSurveys,
);

export const selectOnboardSurveyName = (projectId: number) =>
  createSelector(
    selectOnboardSurveysResource,
    ({ data }) => data?.onboardSurveys.find((survey) => survey.projectId === projectId)?.name,
  );

export const selectOnboardSurvey = (projectId: number) =>
  createSelector(selectOnboardSurveysResource, ({ data }) =>
    data?.onboardSurveys.find((survey) => survey.projectId === projectId),
  );

export const selectDistributionMode = createSelector(
  selectOnboardSurveysResource,
  ({ data }) => data?.distributionMode,
);
